// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgError: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <path
        fill={primary ?? fill ?? '#000'}
        fillRule="evenodd"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
        clipRule="evenodd"
      />
      <path
        fill={secondary ?? fill ?? '#fff'}
        fillRule="evenodd"
        d="M12.053 14.058c-.728 0-1.12-.4-1.133-1.105l-.196-7.242c-.014-.705.531-1.211 1.315-1.211.769 0 1.342.52 1.328 1.225l-.195 7.228c-.014.72-.42 1.105-1.12 1.105m0 4.46c-.826 0-1.553-.64-1.553-1.425 0-.798.713-1.437 1.553-1.437.853 0 1.566.625 1.566 1.437 0 .8-.727 1.425-1.566 1.425"
        clipRule="evenodd"
      />
    </svg>
  );
};

const Memo = memo(SvgError);
export default Memo;
